import { showToast } from '@/helper/toast.helper';
import { saveFileWithPicker } from '@/helper/utils';

type ExportFunction = () => Promise<Blob>;

export const useExportFile = () => {
  const exportFile = async (fetchFn: ExportFunction, defaultFileName: string) => {
    try {
      const blob = await fetchFn();

      const finalName = await saveFileWithPicker(blob, defaultFileName);

      showToast.success(`Exported successfully: ${finalName}!`);
    } catch (error: any) {
      // Don't show error if user cancelled the download
      if (error.message === 'DOWNLOAD_CANCELLED') {
        return; // Silently return without showing any error
      }

      if (error.response?.data instanceof Blob) {
        const msg = JSON.parse(await error.response.data.text())?.message;
        showToast.error(msg);
      } else {
        showToast.error(error.message);
      }
    }
  };

  return { exportFile };
};
